import PropTypes from 'prop-types';

import FormField from '#globalComponents/Forms/FormField';
import Switch from '#globalComponents/Forms/Switch';
import Textarea from '#globalComponents/Forms/Textarea';
import TextInput from '#globalComponents/Forms/TextInput';
import VariableInserter from '#globalComponents/VariableInserter/VariableInserter';

import { RECIPIENT_FIELDS } from '../../constants/recipientFields';

const PROMPT_PLACEHOLDER =
	'z.B. Schreibe eine formelle Anrede mit „Sehr geehrter Herr …“ oder „Sehr geehrte Frau …“. Wenn kein Name bekannt ist, nutze „Sehr geehrte Damen und Herren“.';

/**
 * Type-specific definition inputs: a prompt for ai columns, a field template for formula columns.
 */
const ColumnDefinitionFields = ({ draft, onChange }) => {
	if (draft.type === 'ai') {
		return (
			<>
				<FormField
					label="Anweisung an die KI"
					hint="Die KI kennt Name, Anrede, Position, Firma und Adresse des Empfängers."
				>
					<Textarea
						rows={5}
						value={draft.prompt}
						onChange={(e) => onChange({ prompt: e.target.value })}
						placeholder={PROMPT_PLACEHOLDER}
					/>
				</FormField>
				<div>
					<Switch
						checked={draft.useWebsite}
						onChange={(checked) => onChange({ useWebsite: checked })}
						label="Website der Firma einbeziehen"
					/>
					{draft.useWebsite && (
						<p className="text-[11px] text-bgBase-800 mt-1">
							Nur Empfänger, deren Website gelesen werden kann, erhalten einen Wert. Für alle anderen
							greift der Ersatzwert, sonst werden sie beim Versand übersprungen.
						</p>
					)}
				</div>
			</>
		);
	}

	return (
		<FormField
			label="Zusammensetzung"
			hint="Felder ohne Ersatzwert sind Pflicht: fehlt eines, entsteht kein Wert. Ein leerer Ersatzwert macht ein Feld optional."
		>
			<TextInput
				value={draft.template}
				onChange={(e) => onChange({ template: e.target.value })}
				placeholder="{firstName} {lastName}"
			/>
			<div className="mt-2">
				<VariableInserter
					variables={RECIPIENT_FIELDS}
					braces="single"
					onInsert={(token) =>
						onChange({ template: `${draft.template}${draft.template ? ' ' : ''}${token}` })
					}
				/>
			</div>
		</FormField>
	);
};

ColumnDefinitionFields.propTypes = {
	draft: PropTypes.shape({
		type: PropTypes.oneOf(['ai', 'formula']).isRequired,
		prompt: PropTypes.string,
		template: PropTypes.string,
		useWebsite: PropTypes.bool,
	}).isRequired,
	onChange: PropTypes.func.isRequired,
};

export default ColumnDefinitionFields;
